import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52d628ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "margin-top-20 margin-bottom-20 font-bold font-size-18" }, "基本信息", -1))
const _hoisted_2 = { class: "flex flex-align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 5px","line-height":"1"} }, "至", -1))
const _hoisted_4 = { class: "style-color" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "品质等级", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "margin-top-20 margin-bottom-20 font-bold font-size-18" }, "订单信息", -1))
const _hoisted_7 = { class: "flex flex-align-center" }
const _hoisted_8 = { class: "flex flex-align-center" }
const _hoisted_9 = { class: "margin-left-5" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "margin-left-5 margin-right-5" }, "至", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "margin-left-5" }, "天", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "生产模式", -1))
const _hoisted_14 = { class: "flex flex-algin-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "纸样文件", -1))
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_AddressPicker = _resolveComponent("AddressPicker")!
  const _component_ResponsiveRow = _resolveComponent("ResponsiveRow")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.machineFormData,
    ref: "machineFormRef",
    rules: _ctx.rules,
    "label-width": "110px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ResponsiveRow, null, {
        default: _withCtx(() => [
          _createElementVNode("template", null, [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "客户信息",
              prop: "purchaserId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.machineFormData.purchaserId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.machineFormData.purchaserId) = $event)),
                  placeholder: "请输入客户品名/编码搜索",
                  remote: "",
                  filterable: "",
                  "remote-method": _ctx.fuzzyCustomerRemoteMethod,
                  loading: _ctx.fuzzyCustomerLoading,
                  class: "width-100",
                  onChange: _ctx.handleChangePurchaser
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyCustomerList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.purchaserId,
                        label: `${item.purchaserName}（${item.purchaserCode}）`,
                        value: item.purchaserId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系人",
              prop: "purchaserContactId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.machineFormData.purchaserContactId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.machineFormData.purchaserContactId) = $event)),
                  placeholder: "请选择联系人",
                  class: "width-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.contactId,
                        label: item.contactName,
                        value: item.contactId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "客户款号",
              prop: "customerStyleCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.machineFormData.customerStyleCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.machineFormData.customerStyleCode) = $event)),
                  placeholder: "请输入客户款号",
                  maxlength: 30,
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款式品类",
              prop: "_styleType",
              key: "_styleType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: _ctx.machineFormData._styleType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.machineFormData._styleType) = $event)),
                  options: _ctx.categoryTreeList,
                  props: {
              label: 'value',
              value: 'valueCode'
            },
                  placeholder: "请选择款式品类",
                  style: {"width":"100%"},
                  onChange: _ctx.handleChangeStyleType
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "销售BD",
              prop: "bdId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  modelValue: _ctx.machineFormData.bdName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.machineFormData.bdName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款式季节",
              prop: "clothingStyleSeason"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.machineFormData.clothingStyleSeason,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.machineFormData.clothingStyleSeason) = $event)),
                  multiple: "",
                  clearable: "",
                  disabled: "",
                  class: "width-100",
                  placeholder: "请选择款式季节"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SEASON_LIST, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "设计师",
              prop: "designerId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.machineFormData.designerId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.machineFormData.designerId) = $event)),
                  placeholder: "请输入设计师",
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "remote-method": _ctx.fetchDesignerList,
                  loading: _ctx.fetchDesignerLoading,
                  class: "width-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designerList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        label: `${item.username}（${item.userCode}）`,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "旧版单号",
              prop: "oldPrototypeCode",
              rules: {
            required: _ctx.machineFormData.designerId !== '',
            message: '请输入旧版单号',
            triger: 'blur',
          }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.machineFormData.oldPrototypeCode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.machineFormData.oldPrototypeCode) = $event)),
                  placeholder: "请输入旧版单号",
                  maxlength: 20,
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_el_form_item, {
              label: "码数范围",
              prop: "clothingSizeType",
              class: "reset-form-item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.machineFormData.clothingSizeType,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.machineFormData.clothingSizeType) = $event)),
                    class: "reset-input",
                    placeholder: "尺码类型",
                    clearable: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothesSizeList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.valueCode,
                          label: item.value,
                          value: item.valueCode
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "0",
                    prop: "clothingSizeLowerLimit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.machineFormData.clothingSizeLowerLimit,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.machineFormData.clothingSizeLowerLimit) = $event)),
                        class: "reset-input",
                        placeholder: "尺码",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.valueCode,
                              label: item.value,
                              value: item.valueCode
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_3,
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "0",
                    prop: "clothingSizeUpperLimit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.machineFormData.clothingSizeUpperLimit,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.machineFormData.clothingSizeUpperLimit) = $event)),
                        class: "reset-input",
                        placeholder: "尺码",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.valueCode,
                              label: item.value,
                              value: item.valueCode
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款式颜色",
              prop: "styleColor"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machineFormData.styleColor, (item) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: item,
                      type: "info",
                      class: "margin-right-5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              key: "serviceObjectId",
              label: "服务对象",
              prop: "serviceObjectId"
            }, {
              default: _withCtx(() => [
                (_ctx.baseInfo.isAgency === _ctx.YES_OR_NO_NUMBER_ENUM.YES)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.machineFormData.serviceObjectId,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.machineFormData.serviceObjectId) = $event)),
                      placeholder: "请输入客户名/编码搜索",
                      remote: "",
                      filterable: "",
                      "remote-method": _ctx.fuzzyCustomerRemoteMethod,
                      loading: _ctx.fuzzyCustomerLoading,
                      class: "width-100",
                      onChange: _ctx.handleChangeServiceObject
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyCustomerList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.purchaserId,
                            label: item.purchaserName,
                            value: item.purchaserId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "remote-method", "loading", "onChange"]))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      modelValue: _ctx.machineFormData.serviceObject,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.machineFormData.serviceObject) = $event)),
                      placeholder: "请输入",
                      clearable: "",
                      disabled: "",
                      maxlength: 50
                    }, null, 8, ["modelValue"]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "款式图片",
                  prop: "_stylePictureList"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploader, {
                      modelValue: _ctx.machineFormData._stylePictureList,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.machineFormData._stylePictureList) = $event)),
                      size: "mini",
                      limit: 9,
                      sizeLimit: 20,
                      accept: ".png, .jpg, .jpeg",
                      checkAccept: true,
                      disabled: "",
                      tip: "最多可以上传 9 张图片, 支持png、jpg、jpeg图片格式"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("template", null, [
            _createVNode(_component_el_form_item, { prop: "qualityLevel" }, {
              label: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.machineFormData.qualityLevel,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.machineFormData.qualityLevel) = $event)),
                  placeholder: "请选择品质等级",
                  class: "width-100",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qualityLevelList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.valueCode,
                        value: item.value,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("template", null, [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "单款数量",
              prop: "productionNum"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.machineFormData.productionNum,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.machineFormData.productionNum) = $event)),
                    placeholder: "单款数量",
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.machineFormData.productionUnit,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.machineFormData.productionUnit) = $event)),
                    placeholder: "单款单位",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CLOTHES_UNIT_LIST, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "期望报价",
              prop: "purchaserExpectQuoPrice"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.machineFormData.purchaserExpectQuoPrice,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.machineFormData.purchaserExpectQuoPrice) = $event)),
                    placeholder: "期望报价",
                    class: "flex-1",
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_9, "元/" + _toDisplayString(_ctx.machineFormData.productionUnit), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "货期要求",
              prop: "requireDeliveryTimeLowerLimit"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.machineFormData.requireDeliveryTimeLowerLimit,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.machineFormData.requireDeliveryTimeLowerLimit) = $event)),
                    class: "flex-1",
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_11,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.machineFormData.requireDeliveryTimeUpperLimit,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.machineFormData.requireDeliveryTimeUpperLimit) = $event)),
                    class: "flex-1",
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_12
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("template", null, [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "productionPattern" }, {
                  label: _withCtx(() => [
                    _hoisted_13
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.machineFormData.productionPattern,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.machineFormData.productionPattern) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PRODUCTION_MODELS_LIST, (item) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            key: item.value,
                            label: item.value,
                            class: "margin-right-10"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                (_ctx.machineFormData.productionPattern === _ctx.PRODUCTION_PATTERN_ENUM.CMT)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "领料方式",
                      prop: "pickupFabricWay"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.machineFormData.pickupFabricWay,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.machineFormData.pickupFabricWay) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PICK_WAY_LIST, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: item.value,
                                label: item.value,
                                class: "margin-right-10"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "收货地址",
                  prop: "shippingAddress"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_AddressPicker, {
                        style: {"width":"500px"},
                        province: _ctx.machineFormData.shippingAddress.postProvince,
                        "onUpdate:province": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.machineFormData.shippingAddress.postProvince) = $event)),
                        city: _ctx.machineFormData.shippingAddress.postCity,
                        "onUpdate:city": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.machineFormData.shippingAddress.postCity) = $event)),
                        area: _ctx.machineFormData.shippingAddress.postArea,
                        "onUpdate:area": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.machineFormData.shippingAddress.postArea) = $event))
                      }, null, 8, ["province", "city", "area"]),
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.machineFormData.shippingAddress.postAddressDetail,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.machineFormData.shippingAddress.postAddressDetail) = $event)),
                        placeholder: "请输入详细地址，如 街道 门牌号",
                        maxlength: "200",
                        rows: 1,
                        "show-word-limit": "",
                        class: "margin-left-5"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("template", null, [
            _createVNode(_component_el_form_item, { prop: "designFileUrl" }, {
              label: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_ctx.machineFormData.designFileUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.machineFormData.designFileUrl,
                        download: ""
                      }, _toDisplayString(_ctx.machineFormData.designFileName), 9, _hoisted_16))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "无"))
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.machineFormData.remark,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.machineFormData.remark) = $event)),
                    placeholder: "如送货要求等，限200字符",
                    clearable: "",
                    type: "textarea",
                    maxlength: 200,
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}